import { createReducer, on } from "@ngrx/store";

import { DocumentRequest, RequestActions } from ".";

export interface RequestState {
  requests: DocumentRequest[];
  totalRequests: number;
  completedRequests: number;
  failedRequests: number;
  expired: boolean;
}

export const initialState: RequestState = {
  requests: [],
  totalRequests: 0,
  completedRequests: 0,
  failedRequests: 0,
  expired: false,
};

export const requestReducer = createReducer(
  initialState,

  on(RequestActions.getRequests, state => ({ ...state })),

  on(
    RequestActions.getRequestsSuccess,
    (
      state,
      { requests, totalRequests, completedRequests, failedRequests }
    ) => ({
      ...state,
      requests,
      totalRequests,
      completedRequests,
      failedRequests,
    })
  ),

  on(RequestActions.getRequestsFailure, state => ({
    ...state,
    requests: [],
    totalRequests: 0,
    completedRequests: 0,
    failedRequests: 0,
  }))
);
